export default "/img/TG.c8fb6ce3b4b39d2062e9032a8308cb97.png";